import { Editor, useEditorState } from '@tiptap/react';

import { getToolbarState, type EditorToolbarItem } from './editorActions';

export const useToolbarState = (
  editor: Editor,
  items: readonly EditorToolbarItem[]
) =>
  useEditorState({
    editor,
    selector: ({ editor: instance }) => getToolbarState(instance, items),
  });
